import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { ReactTyped } from "react-typed";
import { format } from "date-fns";
import { UserContext } from "../UserContext";
import { Link } from "react-router-dom";
import CommentSection from "../CommentSection";
import config from "../config";

export default function FullPage() {
  const { userInfo } = useContext(UserContext);
  const { id } = useParams();
  const [postContent, setPostContent] = useState(null);
  const [error, setError] = useState(null); // State to track errors

  useEffect(() => {
    // Fetch the post content
    fetch(`${config.apiUrl}/post/${id}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setPostContent(data);
      })
      .catch((err) => {
        setError(err.message);
      });
  }, [id]);
  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!postContent) {
    return (
      <div>
        Loading <ReactTyped strings={["..."]} typeSpeed={50} loop />{" "}
      </div>
    );
  }

  return (
    <div className="blogpost-full">
      <div className="post-full">
        <h1>{postContent.title}</h1>
        <div className="info-bar">
          <p className="info">
            <time>
              {format(new Date(postContent.createdAt), "dd MMM yyyy, HH:mm")}
            </time>
            <span className="author"> by {postContent.author.username} </span>
          </p>
          {userInfo && userInfo.id === postContent.author._id && (
            <div>
              <Link to={`/edit/${postContent._id}`} className="edit">
                Edit
              </Link>
            </div>
          )}
        </div>

        <div className="image">
          <img src={`${config.apiUrl}/${postContent.path_cover}`} alt="" />
        </div>
        <div
          className="texts"
          dangerouslySetInnerHTML={{ __html: postContent.content }}
        ></div>
      </div>
      <CommentSection postId={id} />
    </div>
  );
}
